import { Component } from '@angular/core';
import { ErrorService } from '../../core/services/error-service';

@Component({
  selector: 'app-error-banner',
  templateUrl: './error-banner.html',
  styleUrls: ['./error-banner.scss'],
  standalone: false
})
export class ErrorBannerComponent {
  constructor(public errorService: ErrorService) {}

  showDetails = false;

  toggleDetails() {
    this.showDetails = !this.showDetails;
  }
  
  close() {
    this.errorService.clear();
  }
}